// البيانات الافتراضية لحالات الصيانة

import { MaintenanceStatusCategory, MaintenanceStatusSubCategory } from '../types/maintenanceStatus';

// الفئات الرئيسية الافتراضية
export const DEFAULT_MAINTENANCE_STATUS_CATEGORIES: Omit<MaintenanceStatusCategory, 'id' | 'createdAt' | 'updatedAt' | 'createdBy'>[] = [
  {
    name: 'أعطال ميكانيكية',
    description: 'الأعطال المتعلقة بالأجزاء الميكانيكية للأجهزة',
    icon: 'build',
    color: 'warning',
    order: 1,
    isActive: true,
    branchId: undefined
  },
  {
    name: 'أعطال كهربائية',
    description: 'الأعطال المتعلقة بالدوائر الكهربائية والإلكترونية',
    icon: 'electric_bolt',
    color: 'error',
    order: 2,
    isActive: true,
    branchId: undefined
  },
  {
    name: 'أعطال برمجية',
    description: 'الأعطال المتعلقة بالبرامج والأنظمة التشغيلية',
    icon: 'computer',
    color: 'info',
    order: 3,
    isActive: true,
    branchId: undefined
  },
  {
    name: 'أعطال شبكة',
    description: 'الأعطال المتعلقة بالاتصال بالشبكة والإنترنت',
    icon: 'wifi',
    color: 'primary',
    order: 4,
    isActive: true,
    branchId: undefined
  },
  {
    name: 'أعطال شاشة',
    description: 'الأعطال المتعلقة بالشاشات والعرض',
    icon: 'display_settings',
    color: 'secondary',
    order: 5,
    isActive: true,
    branchId: undefined
  },
  {
    name: 'أعطال صوت',
    description: 'الأعطال المتعلقة بالصوت والميكروفونات',
    icon: 'volume_up',
    color: 'success',
    order: 6,
    isActive: true,
    branchId: undefined
  }
];

// الفئات الفرعية الافتراضية
export const DEFAULT_MAINTENANCE_STATUS_SUB_CATEGORIES: Omit<MaintenanceStatusSubCategory, 'id' | 'createdAt' | 'updatedAt' | 'createdBy'>[] = [
  // أعطال ميكانيكية
  {
    categoryId: '', // سيتم تعيينه ديناميكياً
    name: 'عطل في المحرك',
    description: 'مشاكل في المحرك أو الأجزاء المتحركة',
    icon: 'settings',
    color: 'warning',
    order: 1,
    isActive: true,
    branchId: undefined
  },
  {
    categoryId: '', // سيتم تعيينه ديناميكياً
    name: 'عطل في التروس',
    description: 'مشاكل في نظام التروس والحركة',
    icon: 'settings',
    color: 'warning',
    order: 2,
    isActive: true,
    branchId: undefined
  },
  {
    categoryId: '', // سيتم تعيينه ديناميكياً
    name: 'عطل في المحامل',
    description: 'مشاكل في المحامل والأجزاء الداعمة',
    icon: 'settings',
    color: 'warning',
    order: 3,
    isActive: true,
    branchId: undefined
  },

  // أعطال كهربائية
  {
    categoryId: '', // سيتم تعيينه ديناميكياً
    name: 'مشاكل في الطاقة',
    description: 'مشاكل في إمداد الطاقة أو البطارية',
    icon: 'power',
    color: 'error',
    order: 1,
    isActive: true,
    branchId: undefined
  },
  {
    categoryId: '', // سيتم تعيينه ديناميكياً
    name: 'مشاكل في الدوائر',
    description: 'مشاكل في الدوائر الكهربائية',
    icon: 'electric_bolt',
    color: 'error',
    order: 2,
    isActive: true,
    branchId: undefined
  },
  {
    categoryId: '', // سيتم تعيينه ديناميكياً
    name: 'مشاكل في الكابلات',
    description: 'مشاكل في الكابلات والوصلات',
    icon: 'cable',
    color: 'error',
    order: 3,
    isActive: true,
    branchId: undefined
  },

  // أعطال برمجية
  {
    categoryId: '', // سيتم تعيينه ديناميكياً
    name: 'مشاكل في النظام',
    description: 'مشاكل في نظام التشغيل',
    icon: 'computer',
    color: 'info',
    order: 1,
    isActive: true,
    branchId: undefined
  },
  {
    categoryId: '', // سيتم تعيينه ديناميكياً
    name: 'مشاكل في البرامج',
    description: 'مشاكل في البرامج والتطبيقات',
    icon: 'apps',
    color: 'info',
    order: 2,
    isActive: true,
    branchId: undefined
  },
  {
    categoryId: '', // سيتم تعيينه ديناميكياً
    name: 'مشاكل في الفيروسات',
    description: 'مشاكل في الفيروسات والبرامج الضارة',
    icon: 'security',
    color: 'error',
    order: 3,
    isActive: true,
    branchId: undefined
  },

  // أعطال شبكة
  {
    categoryId: '', // سيتم تعيينه ديناميكياً
    name: 'مشاكل في الاتصال',
    description: 'مشاكل في الاتصال بالشبكة',
    icon: 'wifi',
    color: 'primary',
    order: 1,
    isActive: true,
    branchId: undefined
  },
  {
    categoryId: '', // سيتم تعيينه ديناميكياً
    name: 'مشاكل في الإنترنت',
    description: 'مشاكل في الاتصال بالإنترنت',
    icon: 'language',
    color: 'primary',
    order: 2,
    isActive: true,
    branchId: undefined
  },
  {
    categoryId: '', // سيتم تعيينه ديناميكياً
    name: 'مشاكل في الواي فاي',
    description: 'مشاكل في الاتصال اللاسلكي',
    icon: 'wifi_off',
    color: 'primary',
    order: 3,
    isActive: true,
    branchId: undefined
  },

  // أعطال شاشة
  {
    categoryId: '', // سيتم تعيينه ديناميكياً
    name: 'مشاكل في العرض',
    description: 'مشاكل في عرض الصورة',
    icon: 'display_settings',
    color: 'secondary',
    order: 1,
    isActive: true,
    branchId: undefined
  },
  {
    categoryId: '', // سيتم تعيينه ديناميكياً
    name: 'مشاكل في الألوان',
    description: 'مشاكل في ألوان الشاشة',
    icon: 'palette',
    color: 'secondary',
    order: 2,
    isActive: true,
    branchId: undefined
  },
  {
    categoryId: '', // سيتم تعيينه ديناميكياً
    name: 'مشاكل في الدقة',
    description: 'مشاكل في دقة الشاشة',
    icon: 'aspect_ratio',
    color: 'secondary',
    order: 3,
    isActive: true,
    branchId: undefined
  },

  // أعطال صوت
  {
    categoryId: '', // سيتم تعيينه ديناميكياً
    name: 'مشاكل في السماعات',
    description: 'مشاكل في السماعات والصوت',
    icon: 'speaker',
    color: 'success',
    order: 1,
    isActive: true,
    branchId: undefined
  },
  {
    categoryId: '', // سيتم تعيينه ديناميكياً
    name: 'مشاكل في الميكروفون',
    description: 'مشاكل في الميكروفون والتسجيل',
    icon: 'mic',
    color: 'success',
    order: 2,
    isActive: true,
    branchId: undefined
  },
  {
    categoryId: '', // سيتم تعيينه ديناميكياً
    name: 'مشاكل في الصوت',
    description: 'مشاكل في جودة الصوت',
    icon: 'volume_up',
    color: 'success',
    order: 3,
    isActive: true,
    branchId: undefined
  }
];

/**
 * دالة لإضافة البيانات الافتراضية لحالات الصيانة
 */
export const addDefaultMaintenanceStatusData = async (userId: string) => {
  try {
    console.log('🔄 إضافة البيانات الافتراضية لحالات الصيانة...');

    const { MaintenanceStatusCategoryService, MaintenanceStatusSubCategoryService } = await import('../services/maintenanceStatusService');

    // إضافة الفئات الرئيسية
    const categoryIds: string[] = [];
    for (const category of DEFAULT_MAINTENANCE_STATUS_CATEGORIES) {
      const newCategory = await MaintenanceStatusCategoryService.addCategory(category, userId);
      categoryIds.push(newCategory.id);
      console.log(`✅ تم إضافة الفئة الرئيسية: ${category.name}`);
    }

    // إضافة الفئات الفرعية مع ربطها بالفئات الرئيسية
    for (let i = 0; i < DEFAULT_MAINTENANCE_STATUS_SUB_CATEGORIES.length; i++) {
      const subCategory = DEFAULT_MAINTENANCE_STATUS_SUB_CATEGORIES[i];
      const categoryIndex = Math.floor(i / 3); // كل 3 فئات فرعية تنتمي لفئة رئيسية واحدة
      const categoryId = categoryIds[categoryIndex];
      
      if (categoryId) {
        await MaintenanceStatusSubCategoryService.addSubCategory({
          ...subCategory,
          categoryId
        }, userId);
        console.log(`✅ تم إضافة الفئة الفرعية: ${subCategory.name}`);
      }
    }

    console.log('✅ تم إضافة جميع البيانات الافتراضية لحالات الصيانة بنجاح');
    return true;
  } catch (error) {
    console.error('❌ خطأ في إضافة البيانات الافتراضية لحالات الصيانة:', error);
    throw error;
  }
}; 